import styled from 'styled-components'

export const FullscreenBackdropContainer = styled.div`
  background-color: rgba(33, 33, 33, 0.5);
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  position: fixed;
  z-index: 1300;
  backdrop-filter: blur(16px);
`

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`
